'use strict';
import {assetProjectReduxItem} from '../redux/assetProjectReduxItem';
import {assetReduxItem} from '../redux/assetReduxItem';
import {organizationReduxItem} from '../redux/organizationReduxItem';
import {orgProfileReduxItem} from '../redux/orgProfileReduxItem';
import {projectReduxItem} from '../redux/projectReduxItem';
import {epics as assignedToModelEpics} from './assignedToModel';
import {epics as hydrateModelEpics} from './hydrateModel';
import {epics as lastAccessedEpics} from './lastAccessed';
import {epics as onAssignUserEpics} from './onAssignUser';
import {epics as onDeletionEpics} from './onDeletion';
import {epics as onNavToEntityEpics} from './onNavToEntity';
import {epics as onNavValidateModelEpics} from './onNavValidateModel';
import {epics as reduxItemModelEpics} from './reduxItemModel';
import {epics as selectedDomainEpics} from './selectedDomain';
import {epics as watchDeletionEpics} from './watchDeletion';


export const epics = [
  ...assignedToModelEpics,
  ...selectedDomainEpics,
  ...hydrateModelEpics,
  ...lastAccessedEpics,
  ...onAssignUserEpics,
  ...onDeletionEpics,
  ...onNavToEntityEpics,
  ...onNavValidateModelEpics,
  ...reduxItemModelEpics,
  ...watchDeletionEpics,
  ...assetProjectReduxItem.epics.epics,
  ...assetReduxItem.epics.epics,
  ...organizationReduxItem.epics.epics,
  ...orgProfileReduxItem.epics.epics,
  ...projectReduxItem.epics.epics,
];



// WEBPACK FOOTER //
// ./src/js/app/model/epics/index.js